<template>
  <h4>Insurance</h4>
  <div class="row mt-2">
    <p>
      The following are standardized Insurance Companies that'll be used throughout the Copilot applications (including ADAS Map, Mobile Copilot,
      Connect Copilot, etc.). 'Push' will push all Insurance company information to all applications.
    </p>
    <p>
      <b>Note:</b> Additions/changes made here automatically propagate to all of the applications, so be very careful in what you do here (especially,
      deletions).
    </p>
  </div>
  <div class="row mt-2">
    <!-- Listing -->
    <div class="col">
      <InsuranceListing @add="addInsurance" @push="processPush" @show="showInsurance" @remove="performRemoval" @saved="savedInsurance" />
    </div>
    <!-- Variations -->
    <div class="col">
      <div v-if="isLoadingLookups"><i class="fas fa-spinner fa-spin"></i> Loading...</div>
      <InsuranceVariations v-else-if="selectedInsurance !== null" ref="variations" @refresh="refreshVariations" />
    </div>
  </div>
  <!-- Dialogs -->
  <DialogInsurance v-model="actionAdd" @close="closeModal" @save="saveNewInsurance" />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { lookupStore } from '@/stores/lookup'
import InsuranceListing from './InsuranceListing.vue'
import InsuranceVariations from './InsuranceVariations.vue'
import DialogInsurance from './DialogInsurance.vue'
export default {
  name: 'InsuranceHost',
  components: {
    InsuranceListing,
    InsuranceVariations,
    DialogInsurance
  },
  data() {
    return {
      actionAdd: null,
      currentInsurance: null,
      confirmTitle: 'Remove',
      confirmAction: 'Remove',
      confirmQuestion: 'Are you sure you wish to delete this Insurance?'
    }
  },
  mounted() {
    this.getInsurance()
  },
  computed: {
    ...mapState(lookupStore, ['loading', 'newInsurance', 'selectedInsurance']),
    isLoadingLookups() {
      let _is = false
      if (this.loading) {
        if (this.loading.insuranceLookup) {
          _is = this.loading.insuranceLookup
        }
      }
      return _is
    }
  },
  methods: {
    ...mapActions(lookupStore, ['getInsurance', 'getInsuranceLookups', 'setInsurance', 'saveInsurance', 'deleteInsurance', 'pushInsurance']),
    resetInsurance() {
      this.currentInsurance = null
      this.setInsurance({
        name: 'add',
        value: null
      })
      if (this.$refs.variations) {
        this.$refs.variations.resetVariation()
      }
    },
    closeModal() {
      this.actionAdd = null
      this.resetInsurance()
    },
    addInsurance() {
      this.resetInsurance()
      this.actionAdd = true
    },
    async processPush(where) {
      if (where === 'ALL') {
        where = null
      }
      await this.pushInsurance(where)
      alert('Insurance Companies are being pushed to all applications.')
    },
    async showInsurance(id) {
      this.setInsurance({
        name: 'selected',
        value: id
      })
      await this.getInsuranceLookups(id)
    },
    async saveNewInsurance() {
      await this.saveInsurance()
      this.closeModal()
      await this.getInsurance()
    },
    async performRemoval(id) {
      if (id) {
        await this.deleteInsurance(id)
        this.resetInsurance()
        await this.getInsurance()
        this.currentInsurance = null
      }
    },
    async refreshVariations() {
      await this.getInsuranceLookups(this.selectedInsurance)
    },
    async savedInsurance(searchTerm) {
      await this.getInsurance()
      this.setInsurance({
        name: 'search',
        value: searchTerm
      })
    }
  }
}
</script>
<style lang="scss" scoped></style>
